// removed by extract-text-webpack-plugin
module.exports = {"formatted-date-container":"_22qLLDCN7Ob3kYiGufCYkq","formatted-date-value":"_2aCV4ph0mw8C3mA8ZFUp_f","positive":"_1Qpmp4p-m69xS6X2055n3d","negative":"_2nOKqO2YTY0mCb-LIdTn7H","spin":"hqQhPrUbvQZmb-EYeIJl-"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/FormattedDate/styles.scss
// module id = 597
// module chunks = 18